import { useBus } from '../../init-plugin';

export default (editModal: any) => {
  useBus().emit('modal.add', editModal);
};
